import styled from 'styled-components';

const Container = styled.div`
  @media (min-width: 768px) {
    padding-left: 40px;
    padding-right: 40px;
    .fore2 {
      padding-left: 50px;
    }
    .tro {
      padding-right: 70px;
      font-size: 16px;
      line-height: 1.625;
    }
  }
  .tro {
    letter-spacing: 0.3px;
  }
  .btn {
    margin-left: 9px;
    padding: 7px 25px;
    letter-spacing: 0.8px;
    line-height: 24px;
  }
  .form-control {
    height: 40px;
    line-height: 24px;
    padding: 7px 10px;
  }
  .input-group {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .list-unstyled a {
    line-height: 38px;
    letter-spacing: 1px;
  }
`;

export default function NotFound() {
  return (
    <Container className="wrapper tw-mt-[40px] desktop:tw-mt-[70px] tw-mb-[40px] desktop:tw-mb-[50px]">
      <div className="tw-flex tw-flex-col desktop:tw-flex-row cm-row">
        <div className="desktop:tw-w-6/12">
          <p className="tro text-center-xs">
            We’re sorry, the page you’re looking for cannot be found. Please contact us at 800.691.0952 with any
            questions or use the search below.
          </p>
          <form id="form1" name="form1" method="get" action="/search/">
            <div className="input-group">
              <input name="q" type="text" id="textarea" className="form-control" />
              <span className="input-group-btn">
                <button className="btn btn-success btn-default" type="submit" value="SEARCH">
                  Search
                </button>
              </span>
            </div>
          </form>
          <ul className="list-unstyled text-center-xs tw-mb-[30px] desktop:tw-mb-0">
            <li>
              <a href="/pages/engagement-rings/">Engagement Rings</a>
            </li>
            <li>
              <a href="/pages/wedding-rings/">Wedding Rings</a>
            </li>
            <li>
              <a href="/pages/diamonds/">Diamonds</a>
            </li>
            <li>
              <a href="/pages/jewelry/">Fine Jewelry</a>
            </li>
            <li>
              <a href="/our-movement/">About</a>
            </li>
          </ul>
        </div>
        <div className="desktop:tw-w-6/12 fore2">
          <div className="error-img">
            <img
              src="https://css.brilliantearth.com/static/img/pic/error404.jpg"
              className="img-responsive center-block"
              alt=""
            />
          </div>
        </div>
      </div>
    </Container>
  );
}
